import React, { useState } from "react";
import { addNewAddress } from "../../account/api";
import { toast } from "react-toastify";
import Modal from "../../../shared/ui/Modal";
import AddressForm from "../../account/components/AddressForm";

const CheckoutAddAddressModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    postCode: "",
    email: "",
    phone: "",
    phone2: "",
  });

  const [loading, setLoading] = useState(false);
  const [phone1Error, setPhone1Error] = useState(false);
  const [phone2Error, setPhone2Error] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const isValid = /^0\d{9}$/.test(value);
      setPhone1Error(!isValid && value.length > 0);
    } else if (name === "phone2") {
      const isValid = /^0\d{9}$/.test(value);
      setPhone2Error(!isValid && value.length > 0);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (selectedOption) => {
    setFormData({ ...formData, state: selectedOption ? selectedOption.value : "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;

    if (formData.state === "") {
      toast.error("Please select a District.");
      hasError = true;
    }

    if (formData.firstName === "") {
      toast.error("Please enter first name");
      hasError = true;
    }

    if (formData.lastName === "") {
      toast.error("Please enter last name");
      hasError = true;
    }

    if (formData.phone.length === 0) {
      toast.error("Primary phone number is required.");
      hasError = true;
    } else if (!/^0\d{9}$/.test(formData.phone)) {
      toast.error("Please enter a valid primary phone number (starts with 0, 10 digits).");
      hasError = true;
    }

    if (formData.phone2.length === 0) {
      toast.error("Secondary phone number (Phone 2) is required.");
      hasError = true;
    } else if (!/^0\d{9}$/.test(formData.phone2)) {
      toast.error("Please enter a valid secondary phone number (Phone 2 must start with 0, 10 digits).");
      hasError = true;
    }

    if (hasError || phone1Error || phone2Error) {
      return;
    }

    setLoading(true);
    try {
      await addNewAddress(formData);
      toast.success("Address saved successfully.");
      onClose();
    } catch (error) {
      console.error("Error saving address:", error.message);
      toast.error("Error saving address. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add new address"
      size="lg"
      dismissible={!loading}
      footer={
        <>
          <button type="button" className="ui-btn ui-btn--ghost" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            type="submit"
            form="checkout-address-form"
            className="ui-btn ui-btn--primary"
            disabled={loading || phone1Error || phone2Error || formData.state === ""}
          >
            {loading ? "Saving…" : "Save address"}
          </button>
        </>
      }
    >
      <AddressForm
        formId="checkout-address-form"
        formData={formData}
        onChange={handleChange}
        onDistrictChange={handleSelectChange}
        onSubmit={handleSubmit}
        phoneError={phone1Error}
        phone2Error={phone2Error}
        districtPlaceholder="Select or type to search..."
        districtRequired
      />
    </Modal>
  );
};

export default CheckoutAddAddressModal;
